"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Trustpilot = _interopRequireDefault(require("../../Trustpilot/Trustpilot"));
var _Carousel = _interopRequireDefault(require("../../Carousel/Carousel"));
var _constants = require("../../constants");
var _ComponentWrapper = _interopRequireDefault(require("../../helpers/ComponentWrapper"));
var _content = require("../../../content");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var CustomTrustPilot = /*#__PURE__*/function (_React$Component) {
  function CustomTrustPilot() {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomTrustPilot);
    _this = _callSuper(this, CustomTrustPilot);
    (0, _defineProperty2["default"])(_this, "setTrustPilotData", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", (0, _content.getTrustPilot)().then(function (data) {
              return data && _this.setState({
                trustPilotData: data,
                isLoading: false
              });
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _this.state = {
      trustPilotData: [],
      isLoading: true
    };
    return _this;
  }
  (0, _inherits2["default"])(CustomTrustPilot, _React$Component);
  return (0, _createClass2["default"])(CustomTrustPilot, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setTrustPilotData();
    }
  }, {
    key: "render",
    value: function render() {
      var reviews = this.state.trustPilotData.reviews;
      var _this$props = this.props,
        hideText = _this$props.hideText,
        small = _this$props.small;
      if (!this.state.isLoading) {
        return /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, /*#__PURE__*/_react["default"].createElement("div", null, !hideText && /*#__PURE__*/_react["default"].createElement("div", {
          className: "text-component max-width-xxs text-center margin-auto"
        }, /*#__PURE__*/_react["default"].createElement("h2", null, "Don\u2019t take our word for it"), /*#__PURE__*/_react["default"].createElement("p", {
          className: "margin-bottom-lg"
        }, "Don\u2019t just take our word for it; hear it straight from the horse\u2019s mouth and read what other sailors had to say.")), /*#__PURE__*/_react["default"].createElement(_Carousel["default"], {
          className: "margin-top-lg",
          settings: {
            slidesToShow: 4,
            autoplay: true,
            dots: false,
            adaptiveHeight: false,
            responsive: [{
              breakpoint: _constants.BREAKPOINTS.LG,
              settings: {
                slidesToShow: small ? 2 : 3
              }
            }, {
              breakpoint: _constants.BREAKPOINTS.MD,
              settings: {
                slidesToShow: 2
              }
            }, {
              breakpoint: _constants.BREAKPOINTS.SM,
              settings: {
                slidesToShow: 1
              }
            }]
          }
        }, reviews.map(function (review) {
          return /*#__PURE__*/_react["default"].createElement(_Trustpilot["default"], {
            key: JSON.stringify(review),
            title: review.title,
            content: (0, _content.textTruncate)(review.text),
            author: review.by,
            date: review.date,
            starsSvg: review.starsSvg,
            starsCount: review.stars
          });
        }))));
      }
      return null;
    }
  }]);
}(_react["default"].Component);
CustomTrustPilot.propTypes = {
  hideText: _propTypes["default"].bool,
  small: _propTypes["default"].bool
};
var _default = exports["default"] = CustomTrustPilot;